import { Suspense, type ReactNode } from "react";
import { Outlet } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { PageTransition, ScrollReveal, ScrollToTop } from "./lib/ScrollReveal";

/**
 * Public website shell (header, footer, motion). All site styles are scoped under .jbs-site so
 * they never reach the admin, LMS or learning portals. The stylesheet is imported last in
 * src/main.tsx so it comes after every Tailwind preflight.
 */
export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="jbs-site">
      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <ScrollToTop />
      <Header />
      <ScrollReveal />
      <main id="main">
        <PageTransition>
          <Suspense
            fallback={<div className="route-loading" aria-busy="true" />}
          >
            {children}
          </Suspense>
        </PageTransition>
      </main>
      <Footer />
    </div>
  );
}

/** Layout route for the public pages. */
export function SiteLayout() {
  return (
    <SiteShell>
      <Outlet />
    </SiteShell>
  );
}
